import { render, staticRenderFns } from "./StepFormIcon.vue?vue&type=template&id=ede7bf9a&scoped=true"
import script from "./StepFormIcon.vue?vue&type=script&lang=js"
export * from "./StepFormIcon.vue?vue&type=script&lang=js"
import style0 from "./StepFormIcon.vue?vue&type=style&index=0&id=ede7bf9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede7bf9a",
  null
  
)

export default component.exports